import { render, staticRenderFns } from "./sss_yc_mx.vue?vue&type=template&id=31a38432&scoped=true"
import script from "./sss_yc_mx.vue?vue&type=script&lang=js"
export * from "./sss_yc_mx.vue?vue&type=script&lang=js"
import style0 from "./sss_yc_mx.vue?vue&type=style&index=0&id=31a38432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a38432",
  null
  
)

export default component.exports